module.exports = __webpack_public_path__ + "a83cc9ed10ec669707004483b0f70849.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/malte-ubl.jpg
 ** module id = 419
 ** module chunks = 0
 **/